import type {State} from 'src/reducers';
import type {NotificationType} from 'src/components/notifications/types';


export const selectNotifications = (state: State): NotificationType[] =>
  state.notifications.notifications.items;
export const selectHasMoreNotifications = (state: State): boolean =>
  state.notifications.notifications.hasMore;
export const selectCursor = (state: State): string =>
  state.notifications.notifications.nextCursor;
export const selectShowBadge = (state: State): boolean =>
  state.notifications.showBadge;
export const selectNotificationFilters = (state: State): string[] =>
  state.notifications.filters;
